import InputCollectionNo from '@/components/molecules/InputCollectionNo/InputCollectionNo.vue'

export { InputCollectionNo }
